// extracted by mini-css-extract-plugin
module.exports = {"container":"doc-nav_container__2X-zZ","title":"doc-nav_title__312rh","description":"doc-nav_description__1G5fB"};